import styled from 'styled-components/macro';
import { fontWeightSemiBold } from 'variables/font';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { CardHeavyShadow } from 'styles/card';
import { FlexCenterVertical } from 'styles/flexbox';
import { grey5 } from 'variables/colors';

export const Root = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-width: 14em;
  padding: 2em 0;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.06);
`;

export const Logo = styled.img`
  width: 9.5em;
  margin: 0 0 3em 1.5em;
`;

export const LinksGroupTitle = styled.h6`
  margin: 0 0 1.3em 2em;
  font-weight: ${fontWeightSemiBold};

  &:not(:first-of-type) {
    margin-top: 3em;
  }
`;

export const Links = styled.div``;

export const StyledChevronIcon = styled(KeyboardArrowDownIcon)`
  transform: rotate(0);

  &.MuiSvgIcon-root {
    transition: 0.2s ease;
  }
`;

export const UserName = styled.h5`
  margin: 0 1em;
`;

export const UserMenu = styled(CardHeavyShadow)`
  position: absolute;
  bottom: 3em;
  width: 12em;
  padding: 1em 0;
`;

export const MenuItem = styled(FlexCenterVertical)`
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: ${grey5};
  }
`;

export const MenuLabel = styled.h5`
  margin-left: 0.75em;
`;

export const User = styled(FlexCenterVertical)`
  position: relative;
  margin-top: auto;
  padding: 0.5em 1.5em;
  cursor: pointer;

  &.active {
    ${StyledChevronIcon} {
      transform: rotate(-180deg);
    }
  }
`;
